// @flow
import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import localization from "moment/locale/ar-ly";
import _ from "lodash";
import Actions from "../../actions/Creators";
import { Layout, Loader, Button } from "../../components/common/";
import CONFIG from "../../config";
import NewOrders from "../../components/dashboard/newOrders/NewOrders";
import {
  DashboardSummary,
  OrderStatusSummary,
  Graph,
  StockRequestsSummary,
  DaySwitch
} from "../../components/dashboard/";
import OrderSummary from "../../components/dashboard/orderSummary/OrderSummary";
import TopProducts from "../../components/dashboard/topProducts/TopProducts";
import I18n from "../../i18n/I18n";
import styles from "./Home.scss";
import wave from "../../images/common/wave.png";
import VatNotification from "../../components/vatNotification/VatNotification";

moment.locale("en");

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      daysSelected: 365
    };
    // this.getDays = this.getDays.bind();
    // this.getDashboardData = this.getDashboardData.bind();
  }

  componentDidMount() {
    if (this.props.user && this.props.seller) {
      this.getDashboardData(this.state.daysSelected);
      this.getOrdersV2Data();
      this.getOrderCount();
      this.getWareHouses();
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.seller !== nextProps.seller) {
      this.getDashboardData(this.state.daysSelected);
      this.getOrdersV2Data();
      this.getOrderCount();
      this.getWareHouses();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.orders !== prevProps.orders &&
      this.props.orders.orders &&
      this.props.orders.orders.message &&
      this.props.orders.orders.message === "ok" &&
      !this.props.isOrderLoading
    ) {
      this.getOrdersV2Data();
      this.getOrderCount();
      this.getWareHouses();
    }
  }

  getDashboardData(days) {
    this.props.dispatch(Actions.getDashboard(days));
    this.setState({
      daysSelected: days
    });
    if (!days) {
      return;
    }
  }

  getOrderCount = () => {
    this.props.dispatch(Actions.getOrderCount("is_fbn=0"));
  };

  getDataByDays = days => {
    this.getDashboardData(days);
    return true;
  };

  getMonths() {
    let months = [];
    moment.locale(this.props.lang === "ar" ? "ar-ly" : "en");
    for (let i = 0; i < 12; i++) {
      months.push(
        moment()
          .subtract(i, "month")
          .format("MMM")
      );
    }
    return months;
  }

  getDays() {
    let days = [];
    for (let i = 0; i < 7; i++) {
      days.push(
        moment()
          .subtract(i, "days")
          .format("dddd")
      );
    }
    return days;
  }

  getDates() {
    let dates = [];
    for (let i = 0; i < 30; i += 5) {
      dates.push(
        moment()
          .subtract(i, "days")
          .format("MMM DD")
      );
    }
    return dates;
  }

  getOrdersV2Data = () => {
    let statusText = "new";

    let query = `limits=5&status=${statusText}`;

    this.props.dispatch(Actions.getOrdersV2(query));
  };

  onAcceptOrder = obj => {
    this.props.dispatch(Actions.postOrdersV2(obj));
  };

  getWareHouses = () => {
    let query = "?is_owned=1";
    this.props.dispatch(Actions.getWareHouses(query));
  };

  getStocksCount = id_partner_warehouse => {
    let query = `id_partner_warehouse=${id_partner_warehouse}`;
    this.setState({
      idWarehouse: id_partner_warehouse
    });
    this.props.dispatch(Actions.getStocksCount(query));
  };

  render() {
    const dash = this.props.dashboard.dashboard;
    const user = this.props.user;
    const {
      seller,
      partnerMenu,
      isNoonUser,
      warehouses,
      stocksCount,
      isLoading,
      sessionIsLoading
    } = this.props;
    const today = new Date();
    const curHr = today.getHours();
    let part = "";

    let labels = this.getMonths();

    switch (this.state.daysSelected) {
      case 365:
        labels = this.getMonths();
        break;

      case 7:
        labels = this.getDays();
        break;

      case 30:
        labels = this.getDates();
        break;
    }

    if (curHr < 12) {
      part = I18n.getText("dashboard.morning-greeting", {}, "Good Morning!");
    } else if (curHr < 18) {
      part = I18n.getText(
        "dashboard.afternoon-greeting",
        {},
        "Good Afternoon!"
      );
    } else {
      part = I18n.getText("dashboard.evening-greeting", {}, "Good Evening!");
    }

    return (
      <Layout currentIndex={1} title={"dashboard.title"}>
        <div className={styles.dashboardCtr}>
          {this.props.isLoading ? (
            <Loader />
          ) : (
            <div>
              {seller ? (
                <div className={styles.dashboardContent}>
                  <div className={styles.notificationWrapper}>
                    {!seller.vat_compliant ? (
                      <VatNotification lang={this.props.lang}>
                        <div className={styles.notiText}>
                          <strong>
                            {I18n.getText(
                              "dashboard.vat-text",
                              {},
                              "Important:"
                            )}
                            &nbsp;
                          </strong>
                          {I18n.getText(
                            "dashboard.vat-notification",
                            {},
                            "Please register your vat details"
                          )}
                        </div>
                        <div className={styles.actnBtn}>
                          <a
                            href={`${CONFIG.PARTNER_URL}/${this.props.lang ||
                              "en"}-ae/partner-vat-registration`}
                            target="_blank"
                          >
                            <Button
                              variant="primary"
                              className={styles.linkBtn}
                            >
                              {I18n.getText(
                                "dashboard.vat-submit-btn",
                                {},
                                "Submit Now"
                              )}
                            </Button>
                          </a>
                        </div>
                      </VatNotification>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className={styles.highBar}>
                    <div className={styles.topWrapper}>
                      <div>
                        <DaySwitch
                          daysSelected={
                            !this.props.isLoading ? this.state.daysSelected : ""
                          }
                          getDataByDays={this.getDataByDays}
                        />
                      </div>
                      {dash && dash.info ? (
                        <DashboardSummary
                          info={dash.info[0]}
                          currencyCode={seller.currency_code}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  {this.props.orders &&
                  this.props.orders.orderCount &&
                  seller.is_fm_pickup &&
                  (!seller.is_allow_stock_request || isNoonUser) ? (
                    <div className={styles.topWrapper}>
                      <OrderStatusSummary data={this.props.orders.orderCount} />
                    </div>
                  ) : (
                    ""
                  )}
                  {seller.is_fm_pickup &&
                  (seller.is_allow_stock_request || isNoonUser) &&
                  warehouses &&
                  warehouses.warehouses ? (
                    <div className={styles.topWrapper}>
                      <StockRequestsSummary
                        warehouses={warehouses && warehouses.warehouses}
                        idWarehouse={this.state.idWarehouse}
                        getStocksCount={this.getStocksCount}
                        counts={stocksCount && stocksCount.counts}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {dash && dash.revenue_graph ? (
                    <div className={styles.graphCtr}>
                      <Graph
                        labels={labels}
                        data={dash.revenue_graph}
                        daysSelected={
                          !this.props.isLoading ? this.state.daysSelected : ""
                        }
                        getDataByDays={this.getDataByDays}
                        lang={this.props.lang}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {(!seller.is_allow_stock_request || isNoonUser) &&
                  this.props.orders &&
                  this.props.orders.orders &&
                  this.props.orders.orders.orders ? (
                    <div className={styles.newOrdersCtr}>
                      <NewOrders
                        data={this.props.orders.orders.orders}
                        lang={this.props.lang}
                        history={this.props.history}
                        currencyCode={seller.currency_code}
                        onAcceptOrder={this.onAcceptOrder}
                      />
                    </div>
                  ) : (
                    ""
                  )}

                  {dash &&
                  dash.orders &&
                  (!seller.is_allow_stock_request || isNoonUser) ? (
                    <div className={styles.newOrdersCtr}>
                      <OrderSummary
                        data={dash.orders}
                        currencyCode={seller.currency_code}
                        browser={this.props.browser}
                      />
                    </div>
                  ) : (
                    ""
                  )}

                  {dash &&
                  dash.top_selling_products &&
                  !_.isEmpty(dash.top_selling_products) ? (
                    <div className={styles.topProducts}>
                      <TopProducts
                        products={dash.top_selling_products}
                        lang={this.props.lang}
                        currencyCode={seller.currency_code}
                        browser={this.props.browser}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
      </Layout>
    );
  }
}
const mapStateToProps = state => {
  return {
    sessionIsLoading: state.session.isLoading,
    session: state.session,
    lang: state.locale.lang,
    user: state.session.user,
    seller: state.session.seller,
    isNoonUser: state.session.isNoonUser,
    dashboard: state.dashboard,
    orders: state.orders,
    isLoading: state.dashboard.isLoading,
    isOrderLoading: state.orders.isLoading,
    browser: state.browser,
    warehouses: state.session.ownedWarehouses,
    isWarehousesLoading: state.session.isWareHousesLoading,
    stocksCount: state.stockRequest.stocksCount
  };
};

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/home/Home.js